namespace SorAraBul.Definitions {
    export interface CurrenciesForm {
        CurrencyCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Symbol: Serenity.StringEditor;
    }

    export class CurrenciesForm extends Serenity.PrefixedContext {
        static formKey = 'Definitions.Currencies';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CurrenciesForm.init)  {
                CurrenciesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CurrenciesForm, [
                    'CurrencyCode', w0,
                    'Name', w0,
                    'Symbol', w0
                ]);
            }
        }
    }
}
